// ** Reducers Imports
import { combineReducers } from "@reduxjs/toolkit";
import auth from "./slices/authSlice";
import event from "./slices/eventSlice";
import user from "./slices/userSlice";
import notInvoiced from "./slices/notInvoicedSlice";
import company from "./slices/companySlice";
import invoice from "./slices/invoiceSlice";
import setting from "./slices/settingSlice"
import contact from "./slices/contactSlice"


// ** Combine Reducers
const rootReducer = combineReducers({
  auth,
  event,
  user,
  notInvoiced,
  company,
  invoice,
  setting,
  contact
});

export default rootReducer;
